import React, { useState, useEffect } from 'react';
import { PageFrame } from '../../components';
import { fetchStaffMembers } from '../../services/api';
import './Staff.css';

const staffGroups = [
  {
    title: '👑 Owners',
    rank: 'Owner',
    roleClass: 'owner',
    emptyMessage: "The fearless leaders of Voxale 👑"
  },
  {
    title: '⚔️ Administrators',
    rank: 'Admin',
    roleClass: 'admin',
    emptyMessage: "Nobody wanted the responsibility... yet 👀"
  },
  {
    title: '🔨 Moderators',
    rank: 'Moderator',
    roleClass: 'mod',
    emptyMessage: "Still searching for brave souls to wield the ban hammer 🔨"
  }
];

function Staff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStaff = async () => {
      const { data, error } = await fetchStaffMembers();
      if (data && !error) {
        setStaff(data);
      }
      setLoading(false);
    };

    loadStaff();
  }, []);

  const getSkinUrl = (username) => {
    return `https://minotar.net/helm/${username}/80.png`;
  };

  const getMembersByRank = (rank) => {
    return staff.filter(member => member.rank === rank);
  };

  return (
    <PageFrame>
      <header className="header">
        <div className="sword-divider">
          <span className="sword-line"></span>
          <span className="sword-icon">🛡️</span>
          <span className="sword-line"></span>
        </div>
        <h1 className="page-title">Our Staff Team</h1>
        <p className="page-subtitle">The guardians who keep Voxale running</p>
      </header>

      {loading ? (
        <p style={{ textAlign: 'center', color: 'var(--wood-medium)' }}>Loading staff...</p>
      ) : (
        staffGroups.map((group, groupIndex) => {
          const members = getMembersByRank(group.rank);
          
          return (
            <React.Fragment key={groupIndex}>
              <h3 className="section-title">
                <span className="title-line"></span>
                {group.title}
                <span className="title-line"></span>
              </h3>

              {members.length > 0 ? (
                <div className="staff-grid">
                  {members.map((member, memberIndex) => (
                    <div className="staff-card" key={memberIndex}>
                      <img 
                        src={getSkinUrl(member.username)} 
                        alt={member.username} 
                        className="staff-avatar-img"
                      />
                      <h3 className="staff-name">{member.username}</h3>
                      <span className={`staff-role ${group.roleClass}`}>{member.rank}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="staff-empty">
                  <p>{group.emptyMessage}</p>
                </div>
              )}
            </React.Fragment>
          );
        })
      )}

      <div className="vote-rewards" style={{ marginTop: '2rem' }}>
        <h3 className="section-title" style={{ marginTop: 0 }}>
          <span className="title-line"></span>
          Join the Team!
          <span className="title-line"></span>
        </h3>
        <p style={{ textAlign: 'center', color: 'var(--wood-medium)', marginBottom: '1rem' }}>
          Want to help make Voxale even better? We're always looking for dedicated players to join our staff team!
        </p>
        <div style={{ textAlign: 'center' }}>
          <a href="#" className="btn btn-gold">Apply on Discord</a>
        </div>
      </div>
    </PageFrame>
  );
}

export default Staff;
